import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@mui/material/CircularProgress";
import FinancialSetting from "Lib/API/FinanceSetting/FinanceSetting";
import deceasedPhoto from "assets/icons/speaker.svg";
import React, { useEffect, useState } from 'react';
import SendLetterHeader from "./SendLetterHeader";
import SendLetterTemplates from "./SendLetterTemplates/SendLetterTemplates";

import { toastr } from "react-redux-toastr";
import { getRandColor } from "utils/emailRandomColors";
import { InputField } from "../InputField";
import Button from "../button/Button";
import EmailEditor from "./EmailEditor/EmailEditor";
import "./sendLetter.scss";

const SendLetter = ({
  closeModal,
  initialEmails = [],
  handleSendLetter,
  sendLetterLoading,
  isMultiple,
  type,
}) => {
  const { getAccessTokenSilently } = useAuth0();


  const [savedEmails, setSavedEmails] = useState([]);
  const [activeTab, setActiveTab] = useState("email");
  const [templates, setTemplates] = useState([]);
  const [templatesOptions, setTemplatesOptions] = useState([]);
  const [selectedTemplateOption, setSelectedTemplateOptions] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [openCreateLetterModal, setOpenCreateLetterModal] = useState(false);
  const [subject, setSubject] = useState("");
  const buttons = [
    {
      id: "cancel",
      label: "Cancel",
      action: closeModal,
      variant: "primary-outline",
    },
    {
      id: "send",
      label: "Send Now",
      action: () => {
        if ((!isMultiple && savedEmails.filter((item) => item.type === "to").length === 0) || sendLetterLoading)
        return;
        sendLetterHandler();
      },
      disabled:
      (!isMultiple && (savedEmails.filter((item) => item.type === "to").length === 0) || 
      sendLetterLoading),
      loading: sendLetterLoading,
      variant: "primary",
    },
  ];


  const sendLetterHandler = () => {
    if(!selectedTemplate?.newTemplate && !selectedTemplate?._id) {
      toastr.info("validation", "Please select a template");
      return;
    }

    if(!subject || !subject?.trim().length) {
      toastr.info("validation", "Please enter a subject");
      return;
    }

    const toEmails = [];
    const ccEmails = [];
    const bccEmails = [];

    savedEmails.forEach((item) => {
      if (item.type === "to") {
        toEmails.push(item.email);
      } else if (item.type === "cc") {
        ccEmails.push(item.email);
      } else if (item.type === "bcc") {
        bccEmails.push(item.email);
      }
    });
    const templateData = {
      ccEmails,
      bccEmails,
      subject,
    }
    if(!isMultiple) {
      templateData.toEmails = toEmails;
    }
    if(selectedTemplate?.newTemplate) {
      templateData.templateInfo = {
        useDefault: selectedTemplate?.useDefault,
        htmlContent: selectedTemplate?.htmlContent,
      }
      if(!selectedTemplate?.useDefault) {
        templateData.templateInfo.replyTo = selectedTemplate?.replyTo;
      }
    } else {
      templateData.templateId = selectedTemplate?._id;
    }
    handleSendLetter(templateData);
  }

  const createLetter = () => {
    setOpenCreateLetterModal(true);
  }

  const getTemplatesHandler = async () => {
    const token = await getAccessTokenSilently();
    const data = {
      filter: {
        templateSource: "user"
      },
    };
    try {
      const response = await FinancialSetting.getTemplatesList(token, data);
      setTemplates(response?.result);
      setTemplatesOptions(response?.result?.map((item) => {
        return {
          label: item?.title,
          value: item?._id,
        }
      }));
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
    }
  }

  const displayInitialEmailsHandler = async () => {
    const uniqueEmails = [...new Set(initialEmails)]; // Remove duplicates using Set
    const emails = uniqueEmails.map((item) => ({
      email: item,
      type: "to",
      image: item?.charAt(0).toUpperCase(),
      color: getRandColor(),
    }));

    setSavedEmails((prev) => [
      ...prev,
      ...emails
    ]);
  };

  useEffect(() => {
    getTemplatesHandler();
    displayInitialEmailsHandler();
  }, []);


  const onSelectTemplateChange = (value) => {
    setSelectedTemplateOptions(value);
    const selectedTemplate = templates?.find((item) => item?._id === value?.value);
    if(!selectedTemplate) return;
    setSelectedTemplate(selectedTemplate);
    setSubject(selectedTemplate?.subject);
  }


  const createNewTemplate = ({template,newTemplate}) => {
    setSelectedTemplate(template);
    setSubject(template?.subject);
    setOpenCreateLetterModal(false);
    if(!newTemplate) {
      setTemplates((prev) => [...prev, template]);
      setTemplatesOptions((prev) => [...prev, {
        label: template?.title,
        value: template?._id,
      }]);
      setSelectedTemplateOptions({
        label: template?.title,
        value: template?._id,
      });
      return;
    }
    setSelectedTemplateOptions(null);
  }


  return (
    <div className="send-letter">
      <div className="send-letter__image">
        <img src={deceasedPhoto} alt="deceased" />
      </div>
      <div className="send-letter__content">
        <div className="send-letter__content__wrapper">
          <SendLetterHeader
            setSavedEmails={setSavedEmails}
            savedEmails={savedEmails}
            closeModal={closeModal}
            title={"Communication Email"}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            isMultiple={isMultiple}
          />
          <hr />
          <div className="send-letter__content__templates">
            <div className="send-letter__content__templates__subject">
              <InputField
                type="text"
                title="Subject"
                mandatory
                {...{
                  name: "subject",
                  placeholder: "Subject",
                  value: subject,
                }}
                handleChange={(e) => {
                  const value = e.target.value;
                  setSubject(value);
                }}
                inputClassName="subject__input"
              />
            </div>
            <SendLetterTemplates 
              createLetter={createLetter}
              templatesOptions={templatesOptions}
              onSelectTemplateChange={onSelectTemplateChange}
              selectedTemplateOption={selectedTemplateOption}
              selectedTemplate={selectedTemplate?.htmlContent || ""}
            />
          </div>
        </div>
        <div className="send-letter__content__actions">
          {buttons.map((button) => (
            <Button
              className={button.className}
              key={button.id}
              variant={button.variant}
              onClick={button.action}
              disabled={button.disabled}
              size="md"
            >
              {button.loading ? (
                <div className="d-flex">
                  <CircularProgress
                    size={22}
                    style={{
                      color: "#ffffff",
                    }}
                  />
                </div>
              ) : (
                button.label
              )}
            </Button>
          ))}
        </div>
      </div>
      <Dialog
        open={openCreateLetterModal}
        onClose={() => {
          setOpenCreateLetterModal(false);
        }}
        PaperProps={{
          style: {
            width: "1200px",
            height: "780px",
            overflow: "hidden",
            borderRadius: "22px",
            maxWidth: "1200px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <EmailEditor 
          closeModal={() => {
            setOpenCreateLetterModal(false);
          }}
          createNewTemplate={createNewTemplate}
          type={type}
          withSubject={true}
        />
      </Dialog>
    </div>
  )
}

export default SendLetter